export const deviceTypeOptions = [
    {value: 'FL1', label: 'FL1'},
    {value: 'FL2', label: 'FL2'},
    {value: 'WINT3', label: 'WINT3'},
];
